import { MarketAttribute } from '@core/constants';
import OfferEvent from '@core/models/offer/OfferEvent';
import Market from '@models/offer/Market';
import {
    MarketFiltersState,
    MarketFilterBasicInfo,
    TournamentId,
} from '@store/modules/ui/sportOffer/marketFilters/types';
import { MAIN_MARKET_ID } from './constants';

export function getSelectedMarket(
    selectedMarkets: MarketFiltersState['selectedMarkets'],
    marketsForTournaments: Record<TournamentId, MarketFilterBasicInfo[]>,
    tournamentId: TournamentId,
): number | null {
    const selectedId = selectedMarkets[tournamentId];
    const marketIds = getMarketIds(marketsForTournaments, tournamentId);
    if (selectedId && marketIds.includes(selectedId)) {
        return selectedId;
    } else {
        return marketIds.length > 0 ? marketIds[0] : null;
    }
}

export function getMarketIds(
    marketsForTournaments: Record<TournamentId, MarketFilterBasicInfo[]>,
    tournamentId: TournamentId,
): number[] {
    return marketsForTournaments[tournamentId]?.map((market) => market.id) || [];
}

export function getPrimaryMarket(
    selectedMarketId: number | null,
    event: OfferEvent,
    fallbackPrimaryMarketAttribute: string = MarketAttribute.main,
    isPrematchMarketForced = false,
): Market | null {
    if (isPrematchMarketForced || selectedMarketId === MAIN_MARKET_ID || !selectedMarketId) {
        return event.getPrematchMarket(fallbackPrimaryMarketAttribute);
    }

    return selectedMarketId ? event.getMarketById(selectedMarketId) : null;
}
